import script from "./ml-date-time.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-date-time.vue?vue&type=script&setup=true&lang=js"

import "./ml-date-time.vue?vue&type=style&index=0&id=5c2567ac&lang=scss"

const __exports__ = script;

export default __exports__